import React, { useState } from "react";

import "../styles.css";

import UserDetails from "./userDetails.js";
import PersonalDetails from "./personalDetails.js";
import Confirm from "./confirm.js";
import Success from "./success.js";

const UserForm = () => {
  const [state, setState] = useState({
    step: 1,
    firstName: "",
    lastName: "",
    email: "",
    occupation: "",
    city: "",
    gender: ""
  });

  const nextStep = () =>
    setState(state => ({
      ...state,
      step: state.step + 1
    }));

  const prevStep = () =>
    setState(state => ({
      ...state,
      step: state.step - 1
    }));

  const handleClick = () =>
    setState(state => ({
      ...state,
      step: state.step - 3,
      firstName: "",
      lastName: "",
      email: "",
      occupation: "",
      city: "",
      gender: ""
    }));

  const handleChange = e => {
    setState({
      ...state,
      [e.target.name]: e.target.value
    });
  };

  const { firstName, lastName, email, occupation, city, gender } = state;

  const values = { firstName, lastName, email, occupation, city, gender };

  switch (state.step) {
    default:
      return null;
    case 1:
      return (
        <UserDetails
          nextStep={nextStep}
          handleChange={handleChange}
          values={values}
          step={state.step}
        />
      );
    case 2:
      return (
        <PersonalDetails
          nextStep={nextStep}
          prevStep={prevStep}
          handleChange={handleChange}
          values={values}
          step={state.step}
        />
      );
    case 3:
      return (
        <Confirm
          nextStep={nextStep}
          prevStep={prevStep}
          handleChange={handleChange}
          values={values}
          step={state.step}
        />
      );
    case 4:
      return <Success handleClick={handleClick} />;
  }
};

export default UserForm;
